module.exports = __webpack_public_path__ + "img/logo.b36f7a7f.svg";